import { ReactNode } from 'react';
import { useRouter } from 'next/router';
import useAuth from '@hooks/useAuth';
import Login from '~/pages/login';
import LoadingScreen from '@components/LoadingScreen';
import { ALLOWED_PATHS } from '~/config';

type Props = {
  children: ReactNode;
};

export default function AuthGuard({ children }: Props) {
  const { isAuthenticated, isInitialized } = useAuth();

  const { pathname } = useRouter();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated && !ALLOWED_PATHS.includes(pathname)) {
    return <Login />;
  }

  return <>{children}</>;
}
